import type { SVGProps } from 'react';

const SvgBannerCharacterOrange = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height={25}
    viewBox='0 0 41 25'
    width={41}
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#bannerOrange)'>
      <path
        d='M20.45 30.183c8.284 0 15-6.716 15-15 0-8.285-6.717-15-15-15-8.285 0-15 6.715-15 15s6.715 15 15 15'
        fill='#FA7C43'
      />
    </g>
    <path
      d='M17.639 12.957c.715 0 1.295-1.008 1.295-2.25 0-1.243-.58-2.25-1.295-2.25s-1.295 1.007-1.295 2.25c0 1.242.58 2.25 1.295 2.25M23.26 12.957c.715 0 1.295-1.008 1.295-2.25 0-1.243-.58-2.25-1.295-2.25s-1.295 1.007-1.295 2.25c0 1.242.58 2.25 1.295 2.25'
      fill='#000'
    />
    <path
      d='M5.125 24.889a5.125 5.125 0 1 0 0-10.25 5.125 5.125 0 0 0 0 10.25M35.773 24.889a5.125 5.125 0 1 0 0-10.25 5.125 5.125 0 0 0 0 10.25'
      fill='#F9560E'
    />
    <defs>
      <clipPath id='bannerOrange'>
        <path d='M5.45.183h30v19h-30z' fill='#fff' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgBannerCharacterOrange;
